import { render, staticRenderFns } from "./attrList.vue?vue&type=template&id=09abd02c"
import script from "./attrList.vue?vue&type=script&lang=js"
export * from "./attrList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports